var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowright(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.344159 0.330173C0.123794 0.541647 0 0.828428 0 1.12745C0 1.42648 0.123794 1.71326 0.344159 1.92473L6.16269 7.50681L0.344159 13.0889C0.130039 13.3016 0.0115592 13.5864 0.0142373 13.8821C0.0169155 14.1778 0.140538 14.4606 0.358478 14.6697C0.576418 14.8788 0.871238 14.9974 1.17944 15C1.48764 15.0025 1.78457 14.8889 2.00626 14.6834L8.65584 8.30409C8.87621 8.09261 9 7.80583 9 7.50681C9 7.20779 8.87621 6.921 8.65584 6.70953L2.00626 0.330173C1.78583 0.118763 1.4869 0 1.17521 0C0.863519 0 0.564591 0.118763 0.344159 0.330173Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrowright.9c84bb049ba23123def089ec5a1f3d9c.svg";
export { ForwardRef as ReactComponent };